import { useSelector } from '@legendapp/state/react';
import { useCallback, useEffect } from 'react';
import { IUserDarkMode, state$ } from '../../state';

const useDarkModeSetup = () => {
  //const currentStoreDarkMode = state$.settings.darkMode.get();
  const currentStoreDarkMode = useSelector(() => state$.settings.darkMode.get());

  // use a callback for good measure
  const callback = useCallback(
    (event: MediaQueryListEvent | MediaQueryList) => {
      const currentDarkModeState = state$.settings.darkMode.get();

      if (currentDarkModeState === IUserDarkMode.USER_SET || currentDarkModeState === IUserDarkMode.NOT_SET_USER || !event) {
        return;
      }

      if (event.matches) {
        return state$.settings.darkMode.set(IUserDarkMode.SYSTEM_SET);
      }

      return state$.settings.darkMode.set(IUserDarkMode.NOT_SET);
    },
    [state$.settings.darkMode]
  );

  callback(window.matchMedia('(prefers-color-scheme: dark)'));

  // handle system changes
  useEffect(() => {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', callback);

    // Remove listener
    return () => {
      window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', callback);
    };
  });

  // update document page state
  useEffect(() => {
    if (currentStoreDarkMode === IUserDarkMode.USER_SET || currentStoreDarkMode === IUserDarkMode.SYSTEM_SET) {
      document.body.setAttribute('data-theme', 'dark');
    }

    if (currentStoreDarkMode === IUserDarkMode.NOT_SET_USER || currentStoreDarkMode === IUserDarkMode.NOT_SET) {
      document.body.removeAttribute('data-theme');
    }
  }, [currentStoreDarkMode]);
};

export default useDarkModeSetup;
